import React from "react";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
function TableLists({ tableData, handleOpenModal, handleDeleteTable }) {
  return (
    <div className="UserList MenuList">
      <table>
        <thead>
          <tr>
            <th>S.N.</th>
            <th>Table Name</th>
            <th>Status</th>
            <th className="Actionsss">Actions</th>
          </tr>
        </thead>
        <tbody>
          {tableData.length === 0 ? (
            <tr>
              <td colSpan="4">No tables available.</td>
            </tr>
          ) : (
            tableData.map((table) => (
              <tr key={table.id}>
                <td>{table.id}</td>
                <td>{table.table_code}</td>
                <td style={{ color: table.status === "1" ? "green" : "red" }}>
                  {table.status === "1" ? "Active" : "Inactive"}
                </td>
                <td className="Actionsss">
                  <Button onClick={() => handleOpenModal(table)}>
                    <EditIcon />
                  </Button>
                  <Button onClick={() => handleDeleteTable(table.id)}>
                    <DeleteIcon />
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default TableLists;
